import api from '../core/api';
import { ApiResponse } from '../core';
import VwRadyolojisablonsaatDTO from 'src/models/RadyolojiModul/VwRadyolojisablonsaatDTO';
import VwHbsRadyolojirandevuDTO from 'src/models/RadyolojiModul/VwHbsRadyolojirandevuDTO';
import HbsCihaztanimDTO from 'src/models/RadyolojiModul/HbsCihaztanimDTO';
import RadyolojiKabulRequests from 'src/models/RadyolojiModul/RadyolojiKabulRequests';
import VwRadyolojiIslemleriDTO from 'src/models/RadyolojiModul/VwRadyolojiIslemleriDTO';
import VwRadyolojiKabulislemlerDTO from 'src/models/RadyolojiModul/VwRadyolojiKabulislemlerDTO';
import RadyolojiKabulAramaKriterleri from 'src/models/RadyolojiModul/RadyolojiKabulAramaKriterleri';
import { RadyolojiRandevuVerRequest } from './RadRequests';
import VwHbsOradCihazDTO from 'src/models/RadyolojiModul/VwHbsOradCihazDTO';
import { RadOnayRequests } from './RadOnayRequests';
import VwHbsRaportippersonelDTO from 'src/models/Raporlama/VwHbsRaportippersonelDTO';


const controllerName = 'Radyoloji';

export const RadyolojiApi = api.injectEndpoints({
  endpoints: (builder) => ({
    radyolojiKabulListeGetir: builder.query<Array<VwRadyolojiKabulislemlerDTO>, RadyolojiKabulAramaKriterleri>({
      query: (request) => ({
        url: controllerName + '/RadyolojiKabulListeGetir',
        method: 'POST',
        body: JSON.stringify(request)
      }),
      providesTags: ['RadyolojiCekim']
    }),
    radyolojiBekleyenTaleplerGetir: builder.query<Array<VwRadyolojiKabulislemlerDTO>, RadyolojiKabulAramaKriterleri>({
      query: (request) => ({
        url: controllerName + '/RadyolojiBekleyenTaleplerGetir',
        method: 'POST',
        body: JSON.stringify(request)
      }),
      providesTags: ['RadyolojiKabul']
    }),
    radyolojiIslemListesiGetir: builder.query<Array<VwRadyolojiIslemleriDTO>, RadyolojiKabulAramaKriterleri>({
      query: (request) => ({
        url: controllerName + '/RadyolojiIslemListesiGetir',
        method: 'POST',
        body: JSON.stringify(request)
      }),
      providesTags: ['RadyolojiKabul']
    }),
    hbsOrderRadyolojiCekim: builder.mutation<boolean, { idList: Array<number> }>({
      query: (request) => ({
        url: controllerName + '/HbsOrderRadyolojiCekim',
        method: 'PUT',
        params: request
      })
    }),
    hbsOrderRadyolojiKabul: builder.mutation<boolean, RadyolojiKabulRequests>({
      query: (request) => ({
        url: controllerName + '/HbsOrderRadyolojiKabul',
        method: 'PUT',
        body: JSON.stringify(request)
      })
    }),
    hbsOrderRadyolojiRed: builder.mutation<boolean, { id: number; redNedenId: number; aciklama: string }>({
      query: (request) => ({
        url: controllerName + '/HbsOrderRadyolojiRed',
        method: 'PUT',
        params: request
      })
    }),
    CihazRandevuGetir: builder.query<
      Array<VwHbsRadyolojirandevuDTO>,
      { cihazId: number; basTarih: string; bitTarih: string }
    >({
      query: (request) => ({
        url: controllerName + '/CihazRandevuGetir',
        method: 'GET',
        params: request
      })
    }),
    cihazlarGetir: builder.query<Array<HbsCihaztanimDTO>, null>({
      query: () => ({
        url: controllerName + '/CihazlarGetir',
        method: 'GET'
      })
    }),

    RadyolojiSablonSaatGetir: builder.query<ApiResponse<Array<VwRadyolojisablonsaatDTO>>, { cihazId: number }>({
      query: (request) => ({
        url: controllerName + '/RadyolojiSablonSaatGetir',
        method: 'GET',
        params: request
      }),
      keepUnusedDataFor: 0
    }),

    CihazRandevuGetirById: builder.query<VwHbsRadyolojirandevuDTO, number>({
      query: (request) => ({
        url: controllerName + '/CihazRandevuGetirById',
        method: 'GET',
        params: {
          id: request
        }
      }),
      keepUnusedDataFor: 0
    }),

    RadyolojiHastaIslemGetir: builder.query<Array<VwHbsOradCihazDTO>, { hastaServisId: number, kimlikId: number, cihazTanimId: number }>({
      query: (request) => ({
        url: controllerName + '/RadyolojiHastaIslemGetir',
        method: 'GET',
        params: request
      }),
      keepUnusedDataFor: 0
    }),

    RadyolojiRandevuVer: builder.mutation<boolean, RadyolojiRandevuVerRequest>({
      query: (request) => ({
        url: controllerName + '/RadyolojiRandevuVer',
        method: 'POST',
        body: JSON.stringify(request)
      }),
    }),

    RadyolojiRandevuAciklamaGuncelle: builder.mutation<boolean, { randevuId: number, aciklama: string }>({
      query: (req) => ({
        url: controllerName + '/RadyolojiRandevuAciklamaGuncelle',
        method: 'PUT',
        params: {
          randevuID: req.randevuId,
          aciklama: req.aciklama
        }
      }),
    }),

    RadyolojiRandevuSil: builder.mutation<boolean, { randevuId: number }>({
      query: (req) => ({
        url: controllerName + '/RadyolojiRandevuSil',
        method: 'DELETE',
        params: {
          randevuId: req.randevuId
        }
      }),
    }),

    RadyolojiRandevuKapat: builder.mutation<boolean, { randevuId: number }>({
      query: (req) => ({
        url: controllerName + '/RadyolojiRandevuKapat',
        method: 'POST',
        params: {
          randevuId: req.randevuId
        }
      }),
    }),

    RadyolojiRaporDurumGuncelle: builder.mutation<boolean, { hastaRaporId: number, durumId: number }>({
      query: (req) => ({
        url: controllerName + '/RadyolojiRaporDurumGuncelle',
        method: 'POST',
        params: req
      }),
    }),

    RadyolojiRaporOnayla: builder.mutation<boolean, RadOnayRequests>({
      query: (req) => ({
        url: controllerName + '/RadyolojiRaporOnayla',
        method: 'POST',
        body: JSON.stringify(req)
      }),
    }),
    RadyolojiRaporOnayIptal: builder.mutation<boolean, RadOnayRequests>({
      query: (req) => ({
        url: controllerName + '/RadyolojiRaporOnayIptal',
        method: 'POST',
        body: JSON.stringify(req)
      }),
    }),

    radyolojiIslemDetayListesiGetir: builder.query<Array<VwRadyolojiIslemleriDTO>, { muracaatId: number }>({
      query: (request) => ({
        url: controllerName + '/RadyolojiIslemDetayListesiGetir',
        method: 'GET',
        params: request
      }),
      providesTags: ['RadyolojiKabul']
    }),

    radyolojiIslemOrderDetayListesiGetir: builder.query<Array<VwRadyolojiIslemleriDTO>, { orderDetayId?: number }>({
      query: (request) => ({
        url: controllerName + '/RadyolojiIslemOrderDetayListesiGetir',
        method: 'GET',
        params: request
      }),
    }),

    raporTipPersonelListe: builder.query<Array<VwHbsRaportippersonelDTO>, { raporTipTanimId: number, turu: number }>({
      query: (request) => ({
        url: controllerName + '/RaporTipPersonelListe',
        method: 'GET',
        params: request
      }),
      providesTags: ['RaporPersonel']

    }),
    raporTipPersonelEkle: builder.mutation<VwHbsRaportippersonelDTO, VwHbsRaportippersonelDTO>({
      query: (request) => {
        return {
          url: controllerName + "/RaporTipPersonelEkle",
          method: "POST",
          body: JSON.stringify(request)
        }
      },
      invalidatesTags: ["RaporPersonel"]
    }),
      raporTipPersonelSil: builder.mutation<boolean, {id: number}>({
      query: (request) => ({
          url: controllerName + "/RaporTipPersonelSil",
          method: "POST",
           params: {
          id: request.id
        }      
      }),
      invalidatesTags: ["RaporPersonel"]
    }),
  })
});

export const {
  useLazyRadyolojiSablonSaatGetirQuery,
  useRadyolojiKabulListeGetirQuery,
  useLazyRadyolojiKabulListeGetirQuery,
  useRadyolojiBekleyenTaleplerGetirQuery,
  useLazyRadyolojiBekleyenTaleplerGetirQuery,
  useRadyolojiIslemListesiGetirQuery,
  useLazyRadyolojiIslemListesiGetirQuery,
  useHbsOrderRadyolojiCekimMutation,
  useHbsOrderRadyolojiKabulMutation,
  useHbsOrderRadyolojiRedMutation,
  useCihazRandevuGetirQuery,
  useLazyCihazRandevuGetirQuery,
  useCihazlarGetirQuery,
  useLazyCihazRandevuGetirByIdQuery,
  useLazyRadyolojiHastaIslemGetirQuery,
  useRadyolojiRandevuVerMutation,
  useRadyolojiRandevuSilMutation,
  useRadyolojiRandevuAciklamaGuncelleMutation,
  useRadyolojiRandevuKapatMutation,
  useRadyolojiRaporDurumGuncelleMutation,
  useRadyolojiRaporOnaylaMutation,
  useRadyolojiIslemDetayListesiGetirQuery,
  useRadyolojiIslemOrderDetayListesiGetirQuery,
  useLazyRadyolojiIslemOrderDetayListesiGetirQuery,
  useRadyolojiRaporOnayIptalMutation,
  useRaporTipPersonelListeQuery,
  useRaporTipPersonelEkleMutation,
  useRaporTipPersonelSilMutation,
} = RadyolojiApi;
